__webpack_require__.p = "https://bmidxbestoniaplprod.netlify.app/";